import script from "./DinhMucCoDinhMetaStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./DinhMucCoDinhMetaStep.vue?vue&type=script&lang=ts&setup=true"

import "./DinhMucCoDinhMetaStep.vue?vue&type=style&index=0&id=4a3e2d4c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a3e2d4c"]])

export default __exports__